import { BaseRouteService } from 'core/services';

class BulkPrintHistoryRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'bulk-print-history/';
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	create(sourceOfChange) {
		return super.create(this.base + '/?sourceOfChange={sourceOfChange}', {sourceOfChange});
	}

	delete(resource) {
		return super.delete(this.base + '{id}', resource);
	}

	print(id, sourceOfChange) {
		return super.get(this.base + 'print/{id}/?sourceOfChange={sourceOfChange}', id, {sourceOfChange});
	}
}

export default BulkPrintHistoryRouteService;
